export default "__VITE_ASSET__dc1c65fe__"